import { Button } from "@/src/components/ui/button";
import { Content } from "@/src/components/wrappers/Content";
import { ActionsContext, useEmit } from "@/src/lib/actions";
import { PlusIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { OperatorsTable } from "./OperatorsTable";
import { Footer } from "@/src/components/ui/footer";
import { Input } from "@/src/components/ui/input";
import { useDebounce } from "@/src/lib/useDebounce";
import { useState, ChangeEvent } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";

export function Operators() {
  return (
    <ActionsContext>
      <Content
        title="Operators"
        contentAction={
          <Button asChild>
            <Link to="/operators/add">
              Add a non-API operator
              <PlusIcon className="ml-2" size={16} />
            </Link>
          </Button>
        }
      >
        <div className="mb-2 flex justify-start items-center gap-2">
          <SearchInput />
          <PageSizeSelect />
        </div>
        <OperatorsTable />
        <Footer />
      </Content>
    </ActionsContext>
  );
}

function SearchInput() {
  const [value, setValue] = useState("");
  const emit = useEmit<string>("op:search");
  const debouncedEmit = useDebounce(emit, 300);

  const onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.currentTarget.value;
    setValue(value);
    debouncedEmit(value);
  };

  return (
    <div className="w-96">
      <Input
        value={value}
        onChange={onChange}
        type="search"
        placeholder="Name filter"
        className="w-full bg-white"
        style={{ padding: "0.5rem" }}
      />
    </div>
  );
}

function PageSizeSelect() {
  const [value, setValue] = useState("10");
  const emit = useEmit<number>("op:page-size");

  const onValueChange = (value: string) => {
    setValue(value);
    emit(parseInt(value));
  };

  return (
    <div className="w-60 ml-auto">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Page size" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="5">Show: 5 at once</SelectItem>
          <SelectItem value="10">Show: 10 at once</SelectItem>
          <SelectItem value="20">Show: 20 at once</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
